import { render, staticRenderFns } from "./DialogDataLoader.vue?vue&type=template&id=383e81f2&"
import script from "./DialogDataLoader.vue?vue&type=script&lang=js&"
export * from "./DialogDataLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports